import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取补充Kyc信息
   * @param params
   * @returns {Promise<any>}
   */
  async getEddKycInfo(params) {
    const res = await dataProxy.get(URL.GET_EDD_KYC_INFO, { params });
    return res;
  },
};
